<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title>
        <h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px">
          <v-icon style="font-size: 20px;">mdi-bookmark-box-multiple</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.cmActivities') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5>
      </v-toolbar-title>
    </v-toolbar>
    <div
      v-show="!collapseContent"
      style="padding: 0 10px 10px 10px;"
    >
      
        <v-layout wrap v-if="content">
          <v-flex xs12>
            <color-picker-item
              :value="content.BookingActTypeColor"
              :label="$t('booking.reservations.activityColor.typeColor', locale)"
              :onChange="handleChangeTypeColor"
              borderRadius="20px 0 0 0"
            />
          </v-flex>
          <v-flex xs12>
            <color-picker-item
              :value="content.BookingActWeekPrimaryColor"
              :label="$t('booking.reservations.activityColor.weekPrimaryColor', locale)"
              :onChange="handleChangeWeekPrimaryColor"
            />
          </v-flex>
          <v-flex xs12>
            <color-picker-item
              :value="content.BookingActWeekSecondaryColor"
              :label="$t('booking.reservations.activityColor.weekSecondaryColor', locale)"
              :onChange="handleChangeWeekSecondaryColor"
            />
          </v-flex>
          <v-flex xs12>
            <color-picker-item
              :value="content.BookingActContentColor"
              :label="$t('booking.reservations.activityColor.contentColor', locale)"
              :onChange="handleChangeContentColor"
            />
          </v-flex>
          <v-flex xs12>
            <color-picker-item
              :value="content.BookingActTitleColor"
              :label="$t('booking.reservations.activityColor.titleColor', locale)"
              :onChange="handleChangeTitleColor"
            />
          </v-flex>
          <v-flex xs12>
            <color-picker-item
              :value="content.BookingActTimeColor"
              :label="$t('booking.reservations.activityColor.timeColor', locale)"
              :onChange="handleChangeTimeColor"
              borderRadius="0 0 20px 0"
            />
          </v-flex>

        </v-layout>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import ColorPickerItem from '@/components/common-components/ColorPickerItem'
  export default {
    name: 'Form48CMActivities',
    components: {
      ColorPickerItem,
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['collapseContent', 'locale']),
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
    mounted () {
      this.prepareContent()
    },
    methods: {
      prepareContent() {
      },
      handleChangeIsModified () {
        this.$store.state.app.isModified = false
      },
      handleChangeTypeColor (v) {
        this.content.BookingActTypeColor = v
        this.handleChangeIsModified ()
      },
      handleChangeWeekPrimaryColor (v) {
        this.content.BookingActWeekPrimaryColor = v
        this.handleChangeIsModified ()
      },
      handleChangeWeekSecondaryColor (v) {
        this.content.BookingActWeekSecondaryColor = v
        this.handleChangeIsModified ()
      },
      handleChangeContentColor (v) {
        this.content.BookingActContentColor = v
        this.handleChangeIsModified ()
      },
      handleChangeTitleColor (v) {
        this.content.BookingActTitleColor = v
        this.handleChangeIsModified ()
      },
      handleChangeTimeColor (v) {
        this.content.BookingActTimeColor = v
        this.handleChangeIsModified ()
      },
    }
  }
</script>

<style scoped>
</style>

